import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Car, IToast, QrScannerComponent, ToastType, User, UserWorkshop} from '@ideenherd';
import {ConvertHelper, DataService, PersistenceService} from '@ideenherd/core/data';
import DevExpress from 'devextreme';
import {ICode} from 'libs/core/data/src/lib/data.service';
import {Subject, Subscription, takeUntil} from 'rxjs';
import {SINECTROUTES} from '../../app-routing.module';
import {AppService} from '../../app.service';
import {CarViewModel} from '../view-models/car.view-model';
import {UserViewModel} from '../view-models/user.view-model';
import {UserWorkshopViewModel} from '../view-models/user-workshop.view-model';
import {EventUserViewModel} from "../view-models/event-user.view-model";

@Component({
  selector: 'ideenherd-event-scanner',
  templateUrl: './event-scanner.component.html',
  styleUrls: ['./event-scanner.component.scss']
})
export class EventScannerComponent implements OnInit, OnDestroy {
  @ViewChild('scanner') scanner: QrScannerComponent
  public QrCodeTitle = QrMessages.PARTICIPANT;
  public toastPosition: DevExpress.PositionConfig = { at: 'top', my: 'center', offset: '0 100' };
  private subscriptions: Subscription = new Subscription();
  private destroy$ = new Subject<void>();
  private scanningDone = false;
  public updateCheckIn = false;
  public userByQrCode: User;

  public eventId = localStorage.getItem('eventId');
  public eventName = localStorage.getItem('eventName');
  public eventInfo = localStorage.getItem('eventInfo');
  public selectedDate = localStorage.getItem('selectedDate');
  public startDate = localStorage.getItem('startDate');
  public endDate = localStorage.getItem('endDate');
  public numberOfDays = JSON.parse(localStorage.getItem('numberOfDays'));

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private dataService: DataService,
    public appService: AppService,
    private persistenceService: PersistenceService
  ) { }
  ngOnInit(): void {
    this.subscriptions.add(this.appService.backButtonS$.subscribe(() => {
      if (window['deviceReady'] == true) {
        document.addEventListener("backbutton", function (e) {
          this.backToEventDetail();
        });
      }
      this.backToEventDetail();
    }));
    const path = this.activeRoute.snapshot.paramMap.get('path');
    if (path === SINECTROUTES.CAR_DETAIL) {
      if (this.appService.driversList.length === 0 || this.appService.updatedDriverindex === 0) {
        this.QrCodeTitle = QrMessages.SCANDRIVER;
      } else {
        this.QrCodeTitle = QrMessages.SCANCODRIVER;
      }
    } else if (path === SINECTROUTES.EVENT_DETAIL) {
      this.QrCodeTitle = QrMessages.PARTICIPANT;
    } else if (path === SINECTROUTES.CAR_OVERVIEW) {
      this.QrCodeTitle = QrMessages.SCANCAR;
    } else {
      this.QrCodeTitle = QrMessages.PARTICIPANT;
    }
  }
  private backToEventDetail = (): void => {
    const path = this.activeRoute.snapshot.paramMap.get('path');
    if (path === SINECTROUTES.CAR_DETAIL) {
      this.router.navigateByUrl('/car-detail');
      this.appService.showBackButton = true;
      this.appService.driversList = [...this.appService.currentDriverlist];
    }
    else if (path === SINECTROUTES.CAR_OVERVIEW) {
      this.router.navigateByUrl('/car-overview');
      this.appService.showBackButton = true;
    }
    else if (path === SINECTROUTES.PARTICIPANT_LIST) {
      this.router.navigateByUrl('/participant-list');
      this.appService.showBackButton = true;
    }
    else if (path === SINECTROUTES.WORKSHOP_PARTICIPANT_LIST) {
      this.router.navigateByUrl('/workshop-participant-list');
      this.appService.showBackButton = true;
    }
    else if (path === SINECTROUTES.PARTICIPANT_DETAIL) {
      this.router.navigateByUrl('/participant-detail');
      this.appService.showBackButton = true;
    }
    else if (path === SINECTROUTES.WORKSHOP_PARTICIPANT_DETAIL) {
      this.router.navigateByUrl('/workshop-participant-detail');
      this.appService.showBackButton = true;
    }
    else {
      this.router.navigateByUrl('/event-detail');
      this.appService.showBackButton = true;
    }
  }

  public scanSuccess(e) {
    const path = this.activeRoute.snapshot.paramMap.get('path');
    const body: ICode = {
      code: e
    }
    if (path === SINECTROUTES.EVENT_DETAIL || path === SINECTROUTES.CAR_OVERVIEW) {
      if (e.includes("_")) {
        const searchTerm = '_';
        const indexOfFirstTerm = e.indexOf(searchTerm);
        const carId = e.substring(e.indexOf(searchTerm, (indexOfFirstTerm + 1)) + 1);
        body.code = carId;
      }
      this.subscriptions.add(
        this.dataService.getCarDetailByCode<Car>(body).subscribe((carDetail) => {
          this.appService.carDetail = new CarViewModel(carDetail);
        }, (error) => {
          const message: IToast = {
            message: "Fahrzeug ungültig",
            type: ToastType.ERROR,
            displayTime: 250
          };
          this.appService.callNotification(message);
          console.error(error);
        }, () => {
          this.appService.currentDriverlist = [];
          this.router.navigate([SINECTROUTES.CAR_DETAIL]);
        }
        )
      );
    } else if (path === SINECTROUTES.CAR_DETAIL) {
      if (e.includes("_")) {
        const searchTerm = '_';
        const indexOfFirstTerm = e.indexOf(searchTerm);
        const participantId = e.substring(indexOfFirstTerm + 1, e.length);
        body.code = participantId;
      }
      this.subscriptions.add(this.dataService.getParticipantByCode<User>(body).pipe(takeUntil(this.destroy$)).subscribe(driverDetail => {
        const driver = new UserViewModel(driverDetail);
        driver.currentEventId = this.appService.eventDetails?.[0]?.id;
        const driverAlreadyAssigned = this.appService.driversList.find(driver => driver.id === driverDetail.u_id);
        if ((this.appService.updatedDriverindex || this.appService.updatedDriverindex === 0) && !driverAlreadyAssigned) {
          this.appService.driversList[this.appService.updatedDriverindex] = driver;
          this.appService.currentDriverlist[this.appService.updatedDriverindex] = driver;
        } else if (!this.appService.updatedDriverindex && !driverAlreadyAssigned) {
          this.appService.driversList.push(driver);
          this.appService.currentDriverlist.push(driver);
        } else {
          const message: IToast = {
            message: "Fahrer bereits zugewiesen",
            type: ToastType.INFO,
            displayTime: 250
          };
          this.appService.callNotification(message);
        }
      }, error => {
        console.error(error);
        const message: IToast = {
          message: "Fahrer ungültig",
          type: ToastType.ERROR,
          displayTime: 250
        };
        this.appService.callNotification(message);
      }, () => {
        this.destroy$.next();
        this.destroy$.complete();
        this.router.navigate([SINECTROUTES.CAR_DETAIL]);
        this.appService.updatedDriverindex = undefined;
      }))
    }
    else if ((path === SINECTROUTES.PARTICIPANT_LIST || path === SINECTROUTES.EVENT_DETAIL_PARTICIPANT || path === SINECTROUTES.PARTICIPANT_DETAIL) && this.scanningDone === false) {

      this.scanningDone = true;
      this.scanner.enableScanner = false;

      let eventId : number;

      if (e.includes("_")) {
        const searchTerm = '_';
        const indexOfFirstTerm = e.indexOf(searchTerm);
        const participantId = e.substring(indexOfFirstTerm + 1, e.length);
        eventId = e.substr(0, e.indexOf(searchTerm));
        body.code = participantId;
      }

      if (eventId) {
        eventId = parseInt(eventId.toString());
      }

      if (!eventId) {
        eventId = parseInt(this.eventId);
      }

      localStorage.setItem('eventId', eventId.toString());

      const event = this.appService.eventDetails.find(event => event.id === eventId);
      localStorage.setItem('eventInfo', event?.info);

      this.subscriptions.add(this.dataService.getParticipantByCode<User>(body).pipe(takeUntil(this.destroy$)).subscribe(participantDetail => {
        const scannedParticipant = new UserViewModel(participantDetail);

        const participantRef = this.appService.participantList?.[eventId]?.[this.selectedDate]?.find(q => q.user.id === scannedParticipant.id);
        const participant = participantRef?.eventUserData ? new EventUserViewModel(participantRef.eventUserData) : null;

        if (participant && !sessionStorage.getItem('alreadyCheckedIn')) {
          delete this.appService.eventParticipantDetail;
          this.appService.eventParticipantDetail = participant;

          if (participant.isCheckedIn(this.selectedDate)) {
            sessionStorage.setItem('alreadyCheckedIn', 'true');
          } else {
            const message: IToast = {
              message: "Teilnehmer erfolgreich eingecheckt",
              type: ToastType.SUCCESS,
              displayTime: 2500
            };
            this.appService.callNotification(message);
          }

          // create unchecked days if not set
          if (this.appService.eventParticipantDetail.checkInDays?.length === 0) {
            for (const day of this.appService.eventParticipantDetail.days) {
              this.appService.eventParticipantDetail.checkOut(day);
            }
          }

          this.appService.eventParticipantDetail.checkIn(this.selectedDate); // Check in participant

          const body = {
            ue_check_in: 1,
            ue_check_in_days: JSON.stringify(this.appService.eventParticipantDetail.checkInDays)
          }

          this.persistenceService.updateUserEventById(participant.id, body).subscribe(() => {

            this.appService.checkInParticipant(participant.id, eventId.toString(), this.selectedDate);
            this.router.navigate([SINECTROUTES.PARTICIPANT_DETAIL]);

          }, () => {
            this.destroy$.next();
            this.destroy$.complete();
          })
        } else {
          const message: IToast = {
            message: "Teilnehmer nicht für den " + ConvertHelper.toDate(this.selectedDate) + " angemeldet",
            type: ToastType.ERROR,
            displayTime: 250
          };
          this.appService.callNotification(message);
          this.appService.scannerProcessLoader = false;
          this.scanner.enableScanner = true;
          this.scanningDone = false;
        }
      }, error => {
        this.appService.scannerProcessLoader = false;
        this.scanner.enableScanner = true;
        this.scanningDone = false;
        this.appService.notrifyError(error);
        console.error(error);
      }, () => {
        this.destroy$.next();
        this.destroy$.complete();
      }));

    }
    else if ((path === SINECTROUTES.WORKSHOP_PARTICIPANT_LIST_SCAN || path === SINECTROUTES.WORKSHOP_PARTICIPANT_DETAIL) && this.scanningDone === false) {
      this.scanningDone = true;
      this.scanner.enableScanner = false;
      this.appService.scannerProcessLoader = true;
      if (e.includes("_")) {
        const searchTerm = '_';
        const indexOfFirstTerm = e.indexOf(searchTerm);
        const participantId = e.substring(indexOfFirstTerm + 1, e.length);
        body.code = participantId;
      }
      this.subscriptions.add(this.dataService.getParticipantByCode<User>(body).pipe(takeUntil(this.destroy$)).subscribe(user => {
        this.userByQrCode = user;
        if (this.appService.workShopUsers.some(ws => (ws.user.id === user.u_id &&
          ws.id.toString() === this.appService.currentWorkshopId))) {
          const body = {
            wu_check_in: new Date().toISOString(),
            wu_check_out: null
          }
          const workShopUser = this.appService.workShopUsers.find(ws => (
            ws.user.id === user.u_id &&
            ws.id.toString() === this.appService.currentWorkshopId
          ));
          this.persistenceService.updateUserWorkShopById(workShopUser.userWorkshopId, body).subscribe((updated) => {
            this.appService.prepareWorkshopData(+this.appService.currentWorkshopId);
          }, error => {
            console.error(error);
          })
          this.updateCheckIn = true;
        }
      }, error => {
        this.appService.scannerProcessLoader = false;
        this.scanningDone = false;
        this.scanner.enableScanner = true;
        this.appService.notrifyError(error);
        console.error(error);
      }, () => {
        const UserWorkshopData = new UserWorkshop({
          wu_check_in: null,
          wu_check_out: null,
          wu_creation_date: new Date().toISOString(),
          wu_u_: this.userByQrCode
        })
        this.appService.currentUserWorkshopDetail = new UserWorkshopViewModel(UserWorkshopData);
        this.appService.scannerProcessLoader = false;
        this.router.navigate([SINECTROUTES.WORKSHOP_PARTICIPANT_DETAIL], {
          state: {
            scan: true,
            updated: this.updateCheckIn
          }
        });
      }));
    }
  }

  clearParticipantData() {
    this.appService.participantList = [];
    this.appService.checkedParticipantList = [];
    this.appService.uncheckedParticipantList = [];
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private playAudio(): void {
    let audio = new Audio();
    audio.src = "../../assets/audio/Barcode-scanner-beep-sound.mp3";
    audio.load();
    audio.play();
  }

  public setSelectedDate(day: string) {
    this.selectedDate = day;
    localStorage.setItem('selectedDate', day);
  }

}
export enum QrMessages {
  SCANCAR = 'Fahrzeug scannen',
  SCANDRIVER = 'Fahrer Code scannen',
  SCANCODRIVER = 'Beifahrer Code scannen',
  PARTICIPANT = 'Teilnehmer Code scannen',
}
